@if (isAuthenticated) {
    <div [class.expanded]="isExpanded" class="sidebar relative flex flex-col h-full">

        <!-- Botão de expandir/recolher -->
        <div class="div-toggle">
            <button (click)="toggleSidebar()" class="button-bar">
                @if (!isExpanded) {
                    <div class="absolute top-12 -right-3 z-50" pTooltip="Expandir">
                        <app-icon-arrow-square-right [color]="'black'" class="img"></app-icon-arrow-square-right>
                    </div>
                } @else {
                    <div class="absolute top-12 -right-3 z-50" pTooltip="Ocultar">
                        <app-icon-arrow-square-left [color]="'black'" class="img"></app-icon-arrow-square-left>
                    </div>
                }
            </button>
        </div>

        <!-- Blocos centralizados -->
        <div class="flex h-full flex-col flex-1 justify-center items-start">

            <!-- Home -->
            <div class="div-color">
                <button
                        (click)="navigate({ firstLabel: 'Início', label: 'Início', iconComponent: 'home', route: '/' })"
                        [class.selected]="isSelected('/')"
                        [pTooltip]="!isExpanded ? 'Home' : undefined"
                        class="button-bar"
                        tooltipPosition="right"
                >
          <span class="icon-wrapper">
            <app-icon-home [color]="'black'" class="img"></app-icon-home>
          </span>
                    @if (isExpanded) {
                        <span class="text-expanded">Home</span>
                    }
                </button>
                <hr class="linha-h"/>
            </div>

            <!-- Controle de Usuários -->
            @if (isAdmin) {
                <div class="div-color">
                    <button
                            (click)="navigate({ firstLabel: 'Início', label: 'Controle de Usuários', iconComponent: 'controle-user', route: '/controle-usuarios' })"
                            [class.selected]="isSelected('/controle-usuarios')"
                            [pTooltip]="!isExpanded ? 'Controle de Usuários' : undefined"
                            class="button-bar"
                            tooltipPosition="right"
                    >
            <span class="icon-wrapper">
              <app-icon-profile-2-user [color]="'black'" class="img"></app-icon-profile-2-user>
            </span>
                        @if (isExpanded) {
                            <span class="text-expanded">Controle de Usuários</span>
                        }
                    </button>
                    <hr class="linha-h"/>
                </div>
            }

            <!-- Controle de Demandas -->
            <div class="div-color">
                <button
                        (click)="navigate({ firstLabel: 'Início', label: 'Controle de Demandas', iconComponent: 'archive-book', route: '/demandas/lista' })"
                        [class.selected]="isSelected('/demandas/lista')"
                        [pTooltip]="!isExpanded ? 'Controle de Demandas' : undefined"
                        class="button-bar"
                        tooltipPosition="right"
                >
          <span class="icon-wrapper">
            <app-icon-archive-book [color]="'black'" class="img"></app-icon-archive-book>
          </span>
                    @if (isExpanded) {
                        <span class="text-expanded">Controle de Demandas</span>
                    }
                </button>
            </div>

        </div>

        <!-- Botão Sair -->
        <div class="div-color mt-auto  ">
            <button
                    (click)="logout()"
                    [pTooltip]="!isExpanded ? 'Sair' : undefined"
                    class="button-bar"
                    tooltipPosition="right"
            >
        <span class="icon-wrapper">
          <app-icon-logout [color]="'black'" class="img"></app-icon-logout>
        </span>
                @if (isExpanded) {
                    <span class="text-expanded">Sair</span>
                }
            </button>
        </div>
        <!-- Versão -->
        <div class="flex justify-center items-center m-x-4">
      <span
              class="text-gray-500 text-center text-sm hover:cursor-default">
        Versão {{ version }}
      </span>
        </div>

    </div>

}
